import React from 'react';

export interface ErrorDisplayProps {
  error: string;
  dataSource: string;
  className?: string;
  onRetry: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  dataSource,
  className = '',
  onRetry,
}) => {
  const lowerError = error.toLowerCase();
  const isApiKeyError = lowerError.includes('api key') || lowerError.includes('not configured');
  const apiKeyMessage = dataSource === 'anthropic'
    ? 'Please configure your Anthropic Admin API key in Settings to view usage data.'
    : 'Please configure your OpenAI Admin API key in Settings to view usage data.';

  return (
    <div className={`p-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg ${className}`}>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <svg className="w-6 h-6 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className="font-medium text-red-800 dark:text-red-200 mb-2">
            {isApiKeyError ? 'Configuration Required' : 'Error Loading Data'}
          </h3>
          <p className="text-red-700 dark:text-red-300 mb-4 text-sm">
            {isApiKeyError ? apiKeyMessage : error}
          </p>
          {isApiKeyError && (
            <p className="text-xs text-red-500 dark:text-red-300/80 mb-4">
              Details: {error}
            </p>
          )}
          <div className="flex gap-3">
            {isApiKeyError ? (
              <button
                onClick={() => {
                  const event = new CustomEvent('openSettings');
                  window.dispatchEvent(event);
                }}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors"
              >
                Open Settings
              </button>
            ) : (
              <button
                onClick={onRetry}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors"
              >
                Retry
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
